@use 'src/core/styles/mediaQueries';

.insightText {
  width: 100%;
  margin-right: 1rem;

  .title {
    font-weight: bold;
  }

  &:not(.inline) .title {
    font-size: 1.125rem;
  }

  &.inline .title {
    margin-right: 4px;
  }

  &:not(.inline) {
    display: flex;
    flex-direction: column;
  }
}

.insight {
  display: grid;
  gap: 0.5em;
  grid-template-columns: 1fr auto;
  padding: 24px 24px 24px 52px;
  border-radius: 72px;
  background: var(--beige-100);
  color: var(--dark-blue-600);

  @include mediaQueries.above-mobile {
    grid-template-columns: 1fr 1.625em;
    padding: 16px 24px 16px 40px;

    &.undismissable {
      grid-template-columns: 1fr;
      padding-right: 40px;
    }
  }

  &.basic {
    padding: 16px;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    color: var(--dark-blue-500);
  }

  &:not(.basic) .insightText {
    margin-right: 1em;
  }
}

.insightWithIcon {
  padding-left: 24px; // leave some room for the icon
}

.insightContentContainer {
  display: flex;
  align-items: center;

  &.inlineIcon {
    display: block;

    @include mediaQueries.above-mobile {
      display: flex;
    }
  }
}

.insightContent {
  flex-direction: column;

  @include mediaQueries.above-mobile {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
}

.iconBackground {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  margin: 0 12px 0 0;
  border-radius: 50%;

  @include mediaQueries.above-mobile {
    margin: 0 16px 0 0;
  }

  &.fixedDimensions {
    width: 28px;
    height: 28px;

    @include mediaQueries.above-mobile {
      width: 40px;
      height: 40px;
    }
  }

  &.inlineIcon {
    width: unset;
    height: unset;
    margin: 0 var(--spacing-xs) 0 0;
    float: left;

    @include mediaQueries.above-mobile {
      width: 2.25em;
      height: 2.25em;
      margin: 0 1em auto 0;
    }
  }
}

.dismissBtn {
  justify-self: end;
  vertical-align: middle;

  @include mediaQueries.above-mobile {
    align-self: center;
  }

  &:hover * > g {
    fill: var(--light-blue-500);
  }
}

.action {
  width: min-content;
  margin-top: 1em;
  color: var(--dark-blue-500);
  font-weight: bold;
  text-decoration: underline;
  white-space: nowrap;

  @include mediaQueries.above-mobile {
    margin: 0;
  }

  &:hover {
    color: var(--light-blue-500);
  }

  &.additional {
    position: relative;
    padding-left: 16px;

    &::before {
      content: '|';
      position: absolute;
      left: 6px;
      color: #ced2d9;
      font-weight: normal;
    }
  }
}
